import React from 'react';
import _ from 'lodash';
import { Card, CardHeader, CardContent, TextField, Stack, FormControlLabel, Radio, FormControl, RadioGroup, Divider, IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { useApplication } from '../../ApplicationsContext';
import { formatDateTime } from '../../../../../services/functions';
import { functions } from '../../functions';


export default function Settlement ({ formik }) {
  const { rowData, setRowData, choices } = useApplication();

  const [netGross, setNetGross] = React.useState(formik.values.to_pay_net_or_gross);

  const handleChangeNetGross = event => {
    setNetGross(event.target.value);
    formik.setFieldValue('to_pay_net_or_gross', event.target.value);
  };

  const addNewPaymentRecord = () => {
    formik.setFieldValue('payment_records', [...formik.values.payment_records, { paid: 0, employment_costs: 0, record_date: formatDateTime(new Date()) }]);
  };

  const addNewBonusPaymentRecord = () => {
    formik.setFieldValue('bonus_payment_records', [...formik.values.bonus_payment_records, { paid: 0, record_date: formatDateTime(new Date()), remarks: '' }]);
  };

  const deleteLatestPaymentRecord = () => {
    formik.setFieldValue('payment_records', formik.values.payment_records.slice(0, -1));
  };

  const deleteLatestBonusPaymentRecord = () => {
    formik.setFieldValue('bonus_payment_records', formik.values.bonus_payment_records.slice(0, -1));
  };

  const onBonusPaymentRecordsInputClick = (val, key) => {
    if (val == '0') {
      formik.setFieldValue('bonus_payment_records', formik.values.bonus_payment_records.map((item, i) => i === key ? { ...item, paid: '' } : item));
    }
  };

  const onBonusPaymentRecordsInputBlur = (val, key) => {
    if (val == '') {
      formik.setFieldValue('bonus_payment_records', formik.values.bonus_payment_records.map((item, i) => i === key ? { ...item, paid: '0' } : item));
    }
  };

  const onPaymentRecordsInputClick = (val, key) => {
    if (val == '0') {
      formik.setFieldValue('payment_records', formik.values.payment_records.map((item, i) => i === key ? { ...item, paid: '' } : item));
    }
  };

  const onPaymentRecordsInputBlur = (val, key) => {
    if (val == '') {
      formik.setFieldValue('payment_records', formik.values.payment_records.map((item, i) => i === key ? { ...item, paid: '0' } : item));
    }
  };

  const onInputClick = (val, key) => {
    if (val == '0') {
      formik.setFieldValue(key, '');
    }
  };

  const onInputBlur = (val, key) => {
    if (val == '') {
      formik.setFieldValue(key, '0');
    }
  };

  const handleChangeBonus = (e, key) => {
    const bonusValue = e.target.value;
    const bonusItem = choices.bonuses.find(bonus => bonus.value === bonusValue);
    formik.setFieldValue('bonus_payment_records', formik.values.bonus_payment_records.map((item, i) => i === key ? { ...item, type: bonusValue, ...bonusItem } : item)
    );
  };


  return (
    <Card >
      <CardHeader title="Rozliczenia"></CardHeader>
      <CardContent>
        <Stack direction="row" spacing={4} alignItems="center">
          <TextField
            type="number"
            name="to_pay"
            label="Do wypłaty"
            value={formik.values.to_pay}
            onChange={formik.handleChange}
            onClick={e => onInputClick(e.target.value, 'to_pay')}
            onBlur={e => onInputBlur(e.target.value, 'to_pay')}
          />
          <FormControl>
            <RadioGroup
              value={netGross}
              onChange={handleChangeNetGross}
            >
              <FormControlLabel value="net" control={<Radio />} label="Netto" />
              <FormControlLabel value="gross" control={<Radio />} label="Brutto" />
            </RadioGroup>
          </FormControl>
          <Stack>
            <Tooltip title="Dodaj kolejną transzę">
              <IconButton color="primary" onClick={addNewPaymentRecord}>
                <AddIcon />
              </IconButton>
            </Tooltip>
            {
              formik.values.payment_records && _.map(formik.values.payment_records, (pr, key) => <Stack direction="row" alignItems="center" mb={1}>
                <TextField
                  size="small"
                  InputLabelProps={{
                    style: {
                      fontSize: 14
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14
                    }
                  }}
                  type="number"
                  label="Kwota transzy"
                  value={pr.paid}
                  disabled={key + 1 == formik.values.payment_records.length ? false : true}
                  sx={{ mr: 2, fontSize: '8px' }}
                  onChange={e => formik.setFieldValue('payment_records', formik.values.payment_records.map((item, i) => i === key ? { ...item, paid: e.target.value } : item))}
                  onClick={e => onPaymentRecordsInputClick(e.target.value, key)}
                  onBlur={e => onPaymentRecordsInputBlur(e.target.value, key)}

                />
                <TextField
                  size="small"
                  InputLabelProps={{
                    style: {
                      fontSize: 14
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14
                    }
                  }}
                  type="number"
                  label="Koszty zatrudnienia"
                  value={pr.employment_costs}
                  // disabled={key + 1 == formik.values.payment_records.length ? false : true}
                  sx={{ mr: 2, fontSize: '8px' }}
                  onChange={e => formik.setFieldValue('payment_records', formik.values.payment_records.map((item, i) => i === key ? { ...item, employment_costs: e.target.value } : item))}
                  // onClick={e => onPaymentRecordsInputClick(e.target.value, key)}
                  // onBlur={e => onPaymentRecordsInputBlur(e.target.value, key)}

                />
                <TextField
                  InputLabelProps={{
                    style: {
                      fontSize: 14
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14
                    }
                  }}
                  size="small"
                  disabled
                  label="Data wpisu"
                  value={formatDateTime(pr.record_date)} />
                <Stack>
                  {key + 1 == formik.values.payment_records.length ? <Tooltip title="Usuń transzę">
                    <IconButton color="error" onClick={deleteLatestPaymentRecord}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip> : null}
                </Stack>
              </Stack>
              )

            }
          </Stack>
          <TextField label="Pozostało do wypłaty" disabled value={Number(formik.values.to_pay) - Number(formik.values.payment_records.reduce((acc, payment) => Number(acc) + Number(payment.paid), 0))}/>
        </Stack>
        <Divider sx={{ my: 4 }}></Divider>
        <Stack sx={{ width: '100%' }} direction="row" spacing={4} alignItems="center" justifyContent="center">
          <Stack spacing={4}>
            <TextField
              name="daily_rate"
              type="number"
              label="Stawka dzienna (PLN)"
              value={formik.values.daily_rate}
              onChange={formik.handleChange}
              onClick={e => onInputClick(e.target.value, 'daily_rate')}
              onBlur={e => onInputBlur(e.target.value, 'daily_rate')}
            />
            {rowData.season_year >= 2025
              ? <TextField
                name="hourly_rate"
                type="number"
                label="Stawka godzinowa styczeń-grudzień"
                value={formik.values.hourly_rate}
                onChange={formik.handleChange}
                onClick={e => onInputClick(e.target.value, 'hourly_rate')}
                onBlur={e => onInputBlur(e.target.value, 'hourly_rate')}
              /> : <>
                <TextField
                  name="hourly_rate_summer"
                  type="number"
                  label="Stawka godzinowa styczeń-czerwiec (PLN)"
                  value={formik.values.hourly_rate_summer}
                  onChange={formik.handleChange}
                  onClick={e => onInputClick(e.target.value, 'hourly_rate_summer')}
                  onBlur={e => onInputBlur(e.target.value, 'hourly_rate_summer')}
                />
                <TextField
                  name="hourly_rate_winter"
                  type="number"
                  label="Stawka godzinowa lipiec-grudzień (PLN)"
                  value={formik.values.hourly_rate_winter}
                  onChange={formik.handleChange}
                  onClick={e => onInputClick(e.target.value, 'hourly_rate_winter')}
                  onBlur={e => onInputBlur(e.target.value, 'hourly_rate_winter')}
                />
              </>
            }
            {rowData.season_year >= 2025 && [functions.INSTRUCTORASSIST].includes(rowData.function_type)
              ? <TextField
                name="hours_worked"
                type="number"
                label="Liczba przepracowanych godzin"
                value={formik.values.hours_worked}
                onChange={formik.handleChange}
                onClick={e => onInputClick(e.target.value, 'hours_worked')}
                onBlur={e => onInputBlur(e.target.value, 'hours_worked')}
              /> : null}
          </Stack>
          <Stack spacing={4}>
            <Stack>
              <Tooltip title="Dodaj kolejny bonus">
                <IconButton color="primary" onClick={addNewBonusPaymentRecord}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
              {
                formik.values.bonus_payment_records && _.map(formik.values.bonus_payment_records, (pr, key) => <Stack direction="row" alignItems="center" mb={1}>
                  <TextField
                    InputLabelProps={{
                      style: {
                        fontSize: 14
                      }
                    }}
                    InputProps={{
                      style: {
                        fontSize: 14
                      }
                    }}
                    size="small"
                    type="number"
                    label="BonusX"
                    value={pr.paid}
                    disabled={key + 1 == formik.values.bonus_payment_records.length ? false : true}
                    // onClick={e => onBonusPaymentRecordsInputClick(e.target.value, key)}
                    // onBlur={e => onBonusPaymentRecordsInputBlur(e.target.value, key)}
                    onChange={e => formik.setFieldValue('bonus_payment_records', formik.values.bonus_payment_records.map((item, i) => i === key ? { ...item, paid: e.target.value } : item))}
                    sx={{ mr: 1 }} />
                  <TextField
                    InputLabelProps={{
                      style: {
                        fontSize: 14
                      }
                    }}
                    InputProps={{
                      style: {
                        fontSize: 13
                      }
                    }}
                    size="small"
                    disabled
                    label="Data wpisu"
                    value={formatDateTime(pr.record_date)}
                    sx={{ mr: 1 }} />

                  {rowData.season_year >= 2025
                    ? (
                      // <h1>abc</h1>
                      <SmallFormTextField
                        sx={{ flex: '1 1 90%' }}
                        select
                        id="type"
                        name="type"
                        label="Rodzaj"
                        disabled={key + 1 == formik.values.bonus_payment_records.length ? false : true}
                        options={choices.bonuses}
                        value={formik.values.bonus_payment_records[key].type ? formik.values.bonus_payment_records[key].type : ''}
                        onChange={e => handleChangeBonus(e, key)}
                        error={formik.touched.resort && Boolean(formik.errors.resort)}
                        // helperText={formik.touched.bonus_payment_records[key].type && formik.errors.bonus_payment_records[key].type}
                      />
                    ) : (
                      <TextField
                        InputLabelProps={{
                          style: {
                            fontSize: 14
                          }
                        }}
                        InputProps={{
                          style: {
                            fontSize: 14
                          }
                        }}
                        size="small"
                        label="Uwagi"
                        value={formik.values.bonus_payment_records[key].remarks}
                        onChange={e => formik.setFieldValue('bonus_payment_records', formik.values.bonus_payment_records.map((item, i) => i === key ? { ...item, remarks: e.target.value } : item))}
                        disabled={key + 1 == formik.values.bonus_payment_records.length ? false : true}
                        multiline
                        rows={2} />)}

                  {key + 1 == formik.values.bonus_payment_records.length ? <Tooltip title="Usuń transzę">
                    <IconButton color="error" onClick={deleteLatestBonusPaymentRecord}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip> : null}
                </Stack>)
              }
            </Stack>

            <TextField
              name="supplements"
              type="number"
              label="Dodatki (PLN)"
              value={formik.values.supplements}
              onChange={formik.handleChange}
              onClick={e => onInputClick(e.target.value, 'supplements')}
              onBlur={e => onInputBlur(e.target.value, 'supplements')}
            />
            <TextField name="supplements_info" type="text" label="Dodatki z tytułu" value={formik.values.supplements_info} onChange={formik.handleChange}/>
          </Stack>
        </Stack>
        <Divider sx={{ my: 4 }}></Divider>
        <Stack>
          <TextField
            name="settlements_notes"
            label="Uwagi do rozliczeń (niewidoczne dla zleceniobiorcy)"
            multiline
            rows={6}
            value={formik.values.settlements_notes}
            onChange={formik.handleChange}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
